import classNames from 'classnames';
import { ForwardedRef, ReactNode, Suspense, lazy, useState } from 'react';

import ReactionIcon from '../icons/ReactionIcon';
import BasicButton, { BasicButtonElement } from './BasicButton';

import styles from '../../styles/buttons/reaction-button.module.css';

const EmojiPicker = lazy(() => import('../partials/EmojiPicker'));

interface ReactionButtonProps {
    className?: string | null;
    onClick?: (() => void | boolean) | null;
    onSelect?: ((reaction: string) => void) | null;
    children?: ReactNode | null;
}

function ReactionButton({
    className = null,
    children = null,
    onClick = null,
    onSelect = null,
    ref: buttonRef = null,
}: ReactionButtonProps & { ref?: ForwardedRef<BasicButtonElement> | null }) {
    const [opened, setOpened] = useState(false);

    const onClickToggle = () => {
        const shouldOpen = onClick === null || onClick() !== false;
        if (shouldOpen && !opened) {
            setOpened(true);
        } else {
            setOpened(false);
        }
    };

    const onEmojiSelect = (emoji: string) => {
        onSelect?.(emoji);
        setOpened(false);
    };

    const onClickBackdrop = () => {
        if (!opened) {
            return;
        }
        setOpened(false);
    };

    return (
        <>
            <BasicButton
                ref={buttonRef}
                className={classNames([styles.container, className])}
                onClick={onClickToggle}
            >
                {children || <ReactionIcon className={styles.icon} />}
            </BasicButton>
            {opened ? (
                <Suspense fallback={null}>
                    <div className={styles.modal}>
                        <EmojiPicker className={styles.picker} onSelect={onEmojiSelect} />
                        <button
                            type="button"
                            className={styles.backdrop}
                            onClick={onClickBackdrop}
                        />
                    </div>
                </Suspense>
            ) : null}
        </>
    );
}

export default ReactionButton;
